/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Codecs_TitleInputs */

const en_fc_home_features_codecs_title = /** @type {(inputs: Fc_Home_Features_Codecs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native codecs`)
};

/**
* | output |
* | --- |
* | "Native codecs" |
*
* @param {Fc_Home_Features_Codecs_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_codecs_title = /** @type {((inputs?: Fc_Home_Features_Codecs_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Codecs_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_codecs_title(inputs)
});
export { fc_home_features_codecs_title as "fc.home.features.codecs.title" }